/**
 * Populates scrolling-gallery-image sections from Instagram when a
 * section.settings.insta_api_key is configured. Fetches the merchant's
 * latest media client-side and swaps it int o the existing gallery markup,
 * one Instagram post per gallery block (cycling if there are more clones
 * than posts).
 */
(function () {
  var INSTAGRAM_FIELDS = 'id,caption,media_type,media_url,thumbnail_url,permalink';

  function InstagramGallery(root) {
    this.root = root;
    this.apiKey = root.dataset.instaApiKey;
    this.limit = Number(root.dataset.instaLimit) || 12;
    this.observer = null;

    if (!this.apiKey) return;
    this.fetchMedia();
  }

  InstagramGallery.prototype.fetchMedia = function () {
    var self = this;
    var url =
      'https://graph.instagram.com/me/media?fields=' +
      encodeURIComponent(INSTAGRAM_FIELDS) +
      '&limit=' +
      encodeURIComponent(this.limit) +
      '&access_token=' +
      encodeURIComponent(this.apiKey);

    fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Instagram API responded with ' + response.status);
        }
        return response.json();
      })
      .then(function (payload) {
        if (payload && payload.error) {
          throw new Error(payload.error.message || 'Instagram API error');
        }
        var media = (payload && payload.data) || [];
        media = media.filter(function (post) {
          return post.media_type === 'VIDEO' ? post.thumbnail_url : post.media_url;
        });
        if (!media.length) return;
        self.populate(media);
      })
      .catch(function (error) {
        console.error('[scrolling-gallery-image] Failed to load Instagram feed:', error);
      });
  };

  InstagramGallery.prototype.populate = function (media) {
    var self = this;

    // Apply immediately to whatever is currently in the DOM.
    this.applyToAll(media);

    // scrolling-promotion clones its item list for the marquee effect the
    // first time it scrolls into view, which can happen after this fetch
    // resolves. Re-apply whenever the DOM inside the root changes so any
    // clones created later also get the real photos.
    if (this.observer) this.observer.disconnect();
    this.observer = new MutationObserver(function () {
      self.applyToAll(media);
    });
    this.observer.observe(this.root, { childList: true, subtree: true });
  };

  InstagramGallery.prototype.applyToAll = function (media) {
    var total = media.length;
    if (!total) return;

    var items = this.root.querySelectorAll('.gallery-list__item[data-gallery-index]');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var index = Number(item.dataset.galleryIndex) % total;
      this.applyToItem(item, media[index]);
    }
  };

  InstagramGallery.prototype.applyToItem = function (item, post) {
    if (!post || item.dataset.instaAppliedId === post.id) return;

    var imageUrl = post.media_type === 'VIDEO' ? post.thumbnail_url : post.media_url;
    if (!imageUrl) return;

    var picture = item.querySelector('.js-insta-image');
    if (picture) {
      var img = picture.querySelector('img');
      if (!img) {
        // No image configured on the block: a placeholder <svg> was rendered
        // instead of an <img>. Swap it for a real <img> we can populate.
        var placeholder = picture.querySelector('.placeholder-svg');
        if (placeholder) placeholder.remove();
        img = document.createElement('img');
        img.loading = 'lazy';
        img.className = 'motion-reduce absolute inset-0 w-full h-full hover-scale-up';
        picture.appendChild(img);
      }
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = imageUrl;
      if (post.caption) img.alt = post.caption.slice(0, 150);
    }

    var link = item.querySelector('.gallery-list__item-wrapper');
    if (link && link.tagName === 'A' && post.permalink) {
      link.href = post.permalink;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }

    // Replace the block's static avatar + heading with the post's own caption.
    var avatar = item.querySelector('.js-insta-avatar');
    if (avatar) avatar.style.display = 'none';

    var caption = item.querySelector('.js-insta-caption');
    if (caption) caption.textContent = post.caption ? post.caption.trim() : '';

    item.dataset.instaAppliedId = post.id;
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('scrolling-promotion[data-insta-api-key]');
    roots.forEach(function (root) {
      new InstagramGallery(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Re-run when a merchant edits/re-renders this section in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
